import { apiClient } from '../../../Utilities/apiClient';

const statisticsService = {
  getHikesCountPerTrail: async (): Promise<{
    data: Array<{
      trailId: number;
      trailName: string;
      hikeCount: number;
    }>;
  }> => {
    return apiClient.get('/admin/statistics/hikes-per-trail');
  },

  getMostHikedTrail: async (): Promise<{
    data: {
      trailId: number;
      trailName: string;
      hikeCount: number;
    } | null;
  }> => {
    return apiClient.get('/admin/statistics/most-hiked-trail');
  },

  getMostSavedTrail: async (): Promise<{
    data: {
      trailId: number;
      trailName: string;
      saveCount: number;
    } | null;
  }> => {
    return apiClient.get('/admin/statistics/most-saved-trail');
  },

  getHikesCompletedCount: async (): Promise<{
    data: {
      count: number;
    };
  }> => {
    return apiClient.get('/admin/statistics/hikes-completed');
  },

  getHikesStartedCount: async (): Promise<{
    data: {
      count: number;
    };
  }> => {
    return apiClient.get('/admin/statistics/hikes-started');
  },

  getMonthlySubscribersCount: async (): Promise<{
    data: {
      count: number;
    };
  }> => {
    return apiClient.get('/admin/statistics/monthly-subscribers');
  },

  getRouteStats: async (): Promise<{
    data: {
      totalRoutes: number;
      byState: {
        draft: number;
        personal: number;
        public: number;
      };
      byStatus: {
        pending: number;
        active: number;
        inactive: number;
      };
      pendingReview: number;
    };
  }> => {
    return apiClient.get('/admin/statistics/routes');
  },

  getTopRouteCreators: async (): Promise<{
    data: {
      creators: Array<{
        userId: number;
        userName: string;
        userEmail: string;
        totalRoutes: number;
        activeRoutes: number;
        pendingRoutes: number;
        rejectedRoutes: number;
      }>;
    };
  }> => {
    return apiClient.get('/admin/statistics/routes/top-creators');
  },

  getTrailsRankedByCompletedHikes: async (): Promise<{
    data: Array<{
      trailId: number;
      trailName: string;
      hikeCount: number;
    }>;
  }> => {
    return apiClient.get('/admin/statistics/trails-ranked-by-completed');
  },

  getTrailsRankedByAttemptedHikes: async (): Promise<{
    data: Array<{
      trailId: number;
      trailName: string;
      hikeCount: number;
    }>;
  }> => {
    return apiClient.get('/admin/statistics/trails-ranked-by-attempted');
  },

  getOnboardingStats: async (): Promise<{
    data: Array<{
      question: string;
      answers: Array<{
        answer: string;
        count: number;
      }>;
    }>;
  }> => {
    return apiClient.get('/admin/statistics/onboarding');
  },
};

export default statisticsService;
